import { createApi } from '@reduxjs/toolkit/query/react';

import {
  EmployeeSalaryEndpoints as Endpoints,
  EmployeeSalaryUrls as Urls,
  type ConfirmRequest,
  type ConfirmResponse,
  type ExportEmployeeSalaryToExcelRequest,
  type ExportEmployeeSalaryToExcelResponse,
  type GetListByRequest,
  type GetListByResponse,
  type RevokeConfirmRequest,
  type RevokeConfirmResponse,
  type SearchEmployeeSalaryEmployeesRequest,
  type SearchEmployeeSalaryEmployeesResponse,
  type UpdateEmployeeSalaryRequest,
  type UpdateEmployeeSalaryResponse,
} from '@app/api/EmployeeSalary/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { EMPLOYEE_SALARY_RESOURCE } from '@app/constants';

export const employeeSalaryApi = createApi({
  reducerPath: 'employeeSalaryApi',
  baseQuery: createApiBaseQuery(EMPLOYEE_SALARY_RESOURCE),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.SearchEmployees]: mutation<
      SearchEmployeeSalaryEmployeesResponse,
      SearchEmployeeSalaryEmployeesRequest
    >({
      query: ({ data, ...params }) => ({
        url: Urls.SearchEmployees,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetListBy]: query<GetListByResponse, GetListByRequest>({
      query: (params) => ({
        url: Urls.GetListBy,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.Update]: mutation<
      UpdateEmployeeSalaryResponse,
      UpdateEmployeeSalaryRequest
    >({
      query: ({ data, ...params }) => ({
        url: Urls.Update,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.Confirm]: mutation<ConfirmResponse, ConfirmRequest>({
      query: ({ data, ...params }) => ({
        url: Urls.Confirm,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.RevokeConfirm]: mutation<
      RevokeConfirmResponse,
      RevokeConfirmRequest
    >({
      query: ({ data, ...params }) => ({
        url: Urls.RevokeConfirm,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.ExportToExcel]: query<
      ExportEmployeeSalaryToExcelResponse,
      ExportEmployeeSalaryToExcelRequest
    >({
      query: (params) => ({
        url: Urls.ExportToExcel,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useSearchEmployeesMutation: useSearchEmployeeSalaryEmployeesMutation,
  useGetListByQuery: useGetEmployeeSalaryListByQuery,
  useLazyGetListByQuery: useLazyGetEmployeeSalaryListByQuery,
  useUpdateMutation: useUpdateEmployeeSalaryMutation,
  useConfirmMutation: useConfirmEmployeeSalaryMutation,
  useRevokeConfirmMutation: useRevokeConfirmEmployeeSalaryMutation,
  useExportToExcelQuery: useExportEmployeeSalaryToExcelQuery,
  useLazyExportToExcelQuery: useLazyExportEmployeeSalaryToExcelQuery,
} = employeeSalaryApi;
